import styled from 'styled-components';
import constants from '../../../core/constants';

// MOBILE FIRST
const WrapLayer = styled.div`
  width: 100%;
  height: 100vh;
  background: #0000003d;
  z-index: 10;
  position: fixed;
  display: block;
  transition: background 0.2s, display 0.3s linear;
  &.active {
    display: none;
  }

  @media (min-width: ${constants.BREAKPOINT_SIZE}px) {
  }
`;

const WrapContainer = styled.div`
  width: 100%;
  height: 100vh;
  background: #ffffff;
  z-index: 10;
  position: fixed;
  display: block;
  transition: position 0.2s, display 0.3s linear;
  & > .icon {
    display: flex;
    justify-content: flex-end;
    min-height: 40px;
    padding: 0px 11px;
    align-items: center;
  }
  & > .icon cc-icon {
    color: var(--interaction-detail);
    cursor: pointer;
  }
  @media (min-width: ${constants.SCREEN_SIZE.sm}px) {
    width: 392px;
    right: 0px;
  }
`;

const WrapModal = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  display: none;
  z-index: 12;
  top: 0px;
  left: 0px;
  &.active {
    display: block;
    background: rgba(81, 85, 93, 0.4);
  }
`;

export { WrapLayer, WrapContainer, WrapModal };
